var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-section"},[_c('div',{staticClass:"button-row"},[_c('Prev'),_c('Menu'),_c('PageUp')],1),_c('div',{staticClass:"button-row"},[(_vm.currentRoute !== 'seaButtonsPage')?_c('Info'):_vm._e(),(_vm.currentRoute === 'seaButtonsPage')?_c('Exit'):_vm._e(),_c('Guide'),_c('PageDown')],1),_c('DirPad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }